module.exports = __webpack_public_path__ + "static/nrc-760486a019cc28682fb021e103d1073b.png";